"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var User = function User($http, SERVER_URL) {
  "ngInject";

  return {
    getList: getList
  };

  function getList(page, limit) {
    if (!page) {
      page = 0;
    }
    if (!limit) {
      limit = 25;
    }
    return $http.get(SERVER_URL + "/users/mobile?page=" + page + "&size=" + limit);
  }
};
exports.default = User;


// WEBPACK FOOTER //
// ./client/app/services/userService/user.service.js